import { render, staticRenderFns } from "./BlockView.vue?vue&type=template&id=5051f3b5&"
import script from "./BlockView.vue?vue&type=script&lang=js&"
export * from "./BlockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports